import React, { useState, useEffect, useContext, useRef } from "react";
import axios from 'axios'
import useScanDetection from 'use-scan-detection';
import DataTable from 'react-data-table-component';
import { useDownloadExcel } from 'react-export-table-to-excel';
import readXlsxFile from 'read-excel-file'

import { GlobalContext, HOST } from "./context/GlobalContext"
import LibroAlmacen from "./LibroAlmacen";
import LibroProv from "./LibroProv";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'
import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Offcanvas from 'react-bootstrap/Offcanvas'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'

import './App.css';
import { Archive, ArchiveFill, BoxSeam, BoxSeamFill, FileExcelFill, Pencil, PencilFill, PlusLg, Power, Upload, X } from "react-bootstrap-icons";

const LIBROS_UPDATE_API = HOST + '/api/inv/libros/update/'
const LIBROS_MASSIVE_API = HOST + '/api/inv/libros/carga/'
const LIBROS_CANCEL_API = HOST + '/api/inv/libros/remove/'
const ALMACEN_LIBROS_MASSIVE_API = HOST + '/api/inv/librosAlmacen/carga/'

const DATE_FORMAT_SHORT = new Intl.DateTimeFormat('es', { year: 'numeric', month: 'long', day: '2-digit', day: '2-digit', timeZone: (Intl.DateTimeFormat().resolvedOptions().timeZone) })

function Libreria() {
  const { setGlobalLoading, formDataToJson, setMailBody, setMailTitle, setShowMesage, getLibros, setCallback, getNombreEditorial, getNombreProveedor, getISBN, showMesage, callback, proveedoresList, editorasList, librosList, almacenList, token, rol } = useContext(GlobalContext);

  const [ removeId, setRemoveId ] = useState(null)
  const [ loading, setLoading ] = useState( false )

  const [ showDesc, setShowDesc ] = useState(false)
  const [ showMassive, setShowMassive ] = useState(false)
  const [ showAlmacenMassive, setShowAlmacenMassive ] = useState(false)
  const [ show, setShow ] = useState(false)
  const [ showAlmacen, setShowAlmacen ] = useState(false)
  const [ showProv, setShowProv ] = useState(false)
  const [ action, setAction ] = useState('Crear Proveedor')
  const [ showNoExists, setShowNoExists ] = useState(false)
  const [ showErrorMasive, setShowErrorMasive ] = useState(false)
  const [ errCode, setErrCode ] = useState(false)

  const [ idLibro, setIdLibro ] = useState(null)
  const [ codigoisbn, setCodigoisbn ] = useState(null)
  const [ titulo, setTitulo ] = useState(null)
  const [ descripcion, setDescripcion ] = useState(0)
  const [ autor, setAutor ] = useState(null)
  const [ idEditora, setIdEditora ] = useState(null)
  const [ provPrincipal, setProvPrincipal ] = useState(null)
  const [ provSecundario, setProvSecundario ] = useState(null)
  const [ precio, setPrecio ] = useState('México')
  const [ costo, setCosto ] = useState(null)
  const [ estatus, setEstatus ] = useState(null)
  const [ isbnTemp, setIsbnTemp ] = useState(null)

  const [ idAlmacen, setIdAlmacen ] = useState()
  const [ file, setFile ] = useState(null)
  const [ field, setField ] = useState(null)
  const [ errorFile, setErrorFile ] = useState(false)

  const tableRef = useRef(null);
  const inputRef = useRef(null);

  const { onDownload } = useDownloadExcel({
      currentTableRef: tableRef.current,
      filename: 'Inventario_libreria_existencias_' + DATE_FORMAT_SHORT.format((new Date()).getTime()) ,
      sheet: 'Inventario'
  })

  useEffect(() => {
    setGlobalLoading( true )
    getLibros()
  }, []);

  useEffect(() => {
    if( showMesage && callback)
      cancelProveedor()
  }, [ callback ]);

  useEffect(() => {
    if(file) {
      let errorMsg = false
      readXlsxFile(file).then((rows) => {
        console.log("file rows", rows)

        rows.map( ( row, idx ) => {
          if( row[0] === null ) {
            setField( "Código ISBN" )
            errorMsg = true
          } else if( row[2] === null ) {
            setField( "Producto" )
            errorMsg = true
          } else if( row[3] === null ) {
            setField( "Precio de lista" )
            errorMsg = true
          } else if( row[7] === null ) {
            setField( "Editorial" )
            errorMsg = true
          } else if( row[8] === null ) {
            setField( "Autor" )
            errorMsg = true
          }
        })

        setErrorFile( errorMsg )
      })
    }
  }, [file]);

  const onScannerChange = (val) => {
    console.log("codigo", val)
    
    if(val) {
      let libro = getISBN(val)
      console.log("libro found", libro)

      if(libro)
        showForm(libro, true)
      else { 
        setIsbnTemp(val)
        setShowNoExists(true)
      }
    }
  }

  useScanDetection({
    onComplete: onScannerChange,
    minLength: 12 // EAN13
  });

  const showForm = (item, desc) => {

    if( item ){
      setAction('Actualizar Libro')
      setIdLibro( item.idLibro )
      setCodigoisbn( item.codigoIsbn )

      setTitulo( item.titulo )
      setDescripcion( item.descripcion )
      setAutor( item.autor )
      setIdEditora( item.idEditora )
      setProvPrincipal( item.provPrincipal )
      setProvSecundario( item.provSecundario )
      setPrecio( item.precio )
      setCosto( item.costo )
      setEstatus( item.estatus )

    } else {
      setAction('Nuevo Libro')
      setIdLibro( null )
      setCodigoisbn( isbnTemp )

      setTitulo( null )
      setDescripcion( null )
      setAutor( null )
      setIdEditora( null )
      setProvPrincipal( null )
      setProvSecundario( null )
      setPrecio( null )
      setCosto( null )
      setEstatus( true )

      setShowNoExists(false)
      setIsbnTemp(null)
    }

    if(desc) setShowDesc(true)
    else setShow(true)
  }

  const showMasiveFile = () => {
    setShowMassive(true)
  }

  const showAlmacenMasiveFile = () => {
    setShowAlmacenMassive(true)
  }

  const updateItem = (e) => {
    e.preventDefault();
    setGlobalLoading( true )
    var form = document.getElementById('driveForm');
		var formData = new FormData(form);
    formData.append('estatus', true);

    var json = formDataToJson(formData)

    console.log('json to update libros', json)

    axios.post(LIBROS_UPDATE_API, json, {
			headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result update", result.data)
      setShow(false)
      setGlobalLoading( false )
      getLibros()
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  const cancelProveedorMsg = (id) => {
    setRemoveId(id)
    setShowMesage(true)
    setMailTitle('Desactivar Libro')
    setMailBody('¿Seguro que desea desactivar el libro? Esta acción podria impactar a la operación.')
  }

  const cancelProveedor = () => {
    setGlobalLoading( true )

    axios.post(LIBROS_CANCEL_API + '?idLibro=' + removeId, {}, {
      headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result cancel", result.data)
      setShowMesage(false)
      setGlobalLoading( false )
      setCallback(false)
      getLibros()
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  const onHandleISBNClose = () => {
    setShowNoExists(false)
    setIsbnTemp(null)
  }

  const sendForm = (e) => {
    e.preventDefault();
    setGlobalLoading( true )
    setLoading(true)

    var form = document.getElementById('visitorForm')
    var formData = new FormData(form)

    axios.post(LIBROS_MASSIVE_API, formData, {
      headers: {
        'Content-type': 'multipart/form-data; charset=utf-8',
        'Authentication': token
      }
    })
    .then(rest => {
      console.log("result uploading photo", rest.data)

      if(rest.data === 'INVALID_ISBN' || rest.data === 'EDITORA_NOT_FOUND' || rest.data === 'EMPTY') {
        setShowErrorMasive(true)
        setErrCode(rest.data)
      }

      setGlobalLoading( false )
      setLoading( false )
      setShowMassive( false )
      getLibros()
    })
    .catch(error => {
      console.log("error", error.message)
      setGlobalLoading( false )
      setLoading( false )
    })
  }

  const sendAlmacenForm = (e) => {
    e.preventDefault();
    setGlobalLoading( true )
    setLoading(true)

    var form = document.getElementById('almacenForm')
    var formData = new FormData(form)

    axios.post(ALMACEN_LIBROS_MASSIVE_API, formData, {
      headers: {
        'Content-type': 'multipart/form-data; charset=utf-8',
        'Authentication': token
      }
    })
    .then(rest => {
      console.log("result uploading photo", rest.data)
      setGlobalLoading( false )
      setLoading( false )
      setShowMassive( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setGlobalLoading( false )
      setLoading( false )
    })
  }

  const activeItem = (idLibro) => {
    setGlobalLoading( true )

    axios.post(LIBROS_UPDATE_API + "?idLibro=" + idLibro, {}, {
			headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result update", result.data)
      setGlobalLoading( false )
      getLibros()
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  const onHandleCloseErrorFile = () => {
    setField(null)
    setFile(null)
    setErrorFile(false)
    inputRef.current.value = null;
  }

  /**************************************** Data Table ****************************************/

  const [filterText, setFilterText] = useState('');
  const [filterProveedor, setFilterProveedor] = useState(null);
  const [filterEditorial, setFilterEditorial] = useState();
	const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);

  const columns = [
    {
      name: <th>Código ISBN</th>,
      selector: row => row.codigoIsbn,
      sortable: true,
    },
    {
      name: <th>Titulo</th>,
      selector: row => row.titulo,
      sortable: true,
    },
    {
      name: <th>Autor</th>,
      selector: row => row.autor,
      sortable: true,
    },
    {
      name: <th>Editora</th>,
      selector: row => getNombreEditorial(row.idEditora).editora,
      sortable: true,
    },
    {
      name: <th>Proveedor</th>,
      selector: row => getNombreProveedor(row.provPrincipal).razonSocial,
      sortable: true,
    },
    {
      name: <th>Existencias</th>,
      selector: row => {
        let consigna = row.librosAlmacen.find( item => item.libroAlmacenPK.idAlmacen === 0 )
        
        if(consigna) return consigna.cantidad
        else return 0        
      },
      sortable: true,
    },
    {
      cell: row => 
      <>
        {  row.estatus ? 
          <>
            { parseInt(rol) === 2 && 
              <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Editar</Tooltip>}>
                <PencilFill onClick={ () => showForm(row) } className="table-icon" />
              </OverlayTrigger>
            }
            <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Almacenes</Tooltip>}>
              <ArchiveFill onClick={ () => { setIdLibro(row.idLibro); setShowAlmacen(true); } } className="table-icon" />
            </OverlayTrigger>
            <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Proveedores</Tooltip>}>
              <BoxSeamFill onClick={ () => { setIdLibro(row.idLibro); setShowProv(true); } } className="table-icon" />
            </OverlayTrigger>                      
            { parseInt(rol) === 2 && 
              <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Borrar</Tooltip>}>
                <X onClick={ () => cancelProveedorMsg(row.idLibro) } className="table-icon" />
              </OverlayTrigger>
            }
          </> : 
          <>
            <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Activar</Tooltip>}>
              <Power onClick={ () => activeItem(row.idLibro) } className="table-icon" />
            </OverlayTrigger>
          </>
        }
      </>,
    },
  ];

  useEffect(() => {
    if( librosList.length > 0) {
      let data = librosList

      if(filterText && filterText !== '' ) {
        data = librosList.filter(
          item => (item.titulo && item.titulo.toLowerCase().includes(filterText.toLowerCase())) || (item.codigoIsbn && item.codigoIsbn.toLowerCase().includes(filterText.toLowerCase())),
        )
      }

      if(filterEditorial && parseInt(filterEditorial) > -1 ) {
        data = data.filter(
          item => item.idEditora && parseInt( item.idEditora ) === parseInt( filterEditorial ),
        )
      }

      if(filterProveedor && parseInt(filterProveedor) > -1 ) {
        data = data.filter(
          item => item.provPrincipal && parseInt( item.provPrincipal ) === parseInt( filterProveedor ),
        )
      }

      console.log("data filtered", data)
      setFilteredItems(data);
    }
  }, [ librosList, filterText, filterProveedor, filterEditorial ]);

  /**************************************** Data Table ****************************************/

  return (
    <>
      <Modal show={errorFile} onHide={ () => onHandleCloseErrorFile() }>
        <Modal.Header closeButton>
          <div className="title-form">{ 'Error' }</div>
        </Modal.Header>
        <Modal.Body>
          <div className="forgoten-pass"> { 'El Archivo Excel contiene un registro vacio en la columna ' } <b>{ field }</b> { '. Esta columna no puede contener valores vacios. ' } </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="cancel-btn" onClick={ () => onHandleCloseErrorFile() }> Cerrar </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showErrorMasive} onHide={ () => setShowErrorMasive(false) }>
        <Modal.Header closeButton>
          <div className="title-form">{ 'Error' }</div>
        </Modal.Header>
        <Modal.Body>
          <div className="forgoten-pass"> { 'La carga del archivo fallo en todos o algunos registros.' } </div><br/>
          <div className="forgoten-pass" style={{ fontSize: 18 }}> { 'Error' } </div>
          { errCode === 'INVALID_ISBN' &&  <div className="forgoten-pass"> { 'El formato de la columna del CÓDIGO DE BARRAS no es valido, favor de verificar que la columna de CÓDIGO DE BARRAS sea de tipo TEXTO.' } </div> }
          { errCode === 'EDITORA_NOT_FOUND' && <div className="forgoten-pass"> { 'No se encontraron registradas en el sistema algunas EDITORIALES presentadas en el archivo proporcionado. Favor de verificar si la EDITORIAL esta correctamente escrita en el sistema o en el archivo, o en su caso, registrar la EDITORA y asociarla a un proveedor válido.' } </div> }
          { errCode === 'EMPTY' && <div className="forgoten-pass"> { 'El archivo parece no tener registros o formato válido.' } </div> }
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="cancel-btn" onClick={ () => setShowErrorMasive(false) }> Cerrar </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showNoExists} onHide={ () => onHandleISBNClose() }>
        <Modal.Header closeButton>
          <div className="title-form">{ 'Error' }</div>
        </Modal.Header>
        <Modal.Body>
          <div className="forgoten-pass"> { 'Código ISBN no encontrado. ¿Deseas registrar este producto a partir de este código ISBN?' } </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="cancel-btn" onClick={ () => onHandleISBNClose() }> Cerrar </button>
          <button type="button" className="grl-btn" onClick={ () => showForm() }> Crear </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showAlmacenMassive} onHide={ () => setShowAlmacenMassive(false) }>
        <Modal.Header closeButton>
          <div className="title-form">{ 'Librería - Carga Masiva Salidas' }</div>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Form id='almacenForm' onSubmit={ sendAlmacenForm }>
              <div>
                <div> Puedes subir un <span style={{ color: "#ae0107" }}>ARCHIVO</span> .xlsx para poder subir varias <b>salidas de libros</b> a la vez. </div>
                <br/>
                <Form.Group className='mb-3'>
                  <FloatingLabel label="Almacenes">
                    <Form.Select required name="idAlmacen" value={ idAlmacen } onChange={ (e) => setIdAlmacen( e.target.value ) }>
                      <option>Selecciona una opción</option>
                      { almacenList.map( item => (
                        <option key={ item.idAlmacen } value={ item.idAlmacen }>{ item.almacen }</option>
                      ))}
                    </Form.Select>
                  </FloatingLabel>
                </Form.Group>
                <br/>
                <input required className='file' type="file" name="almacenes" onChange={ (e) => setFile(e.target.files[0]) } style={{ fontSize: '11px' }} />
                <br/>
                <div align="right">
                  <Button disabled={ loading } className='single-btn' type="submit">
                    <Spinner animation="border" variant="light" role="status" className={ loading ? 'spin' : 'hide' }/>
                    <span className={ loading ? 'hide' : 'btn-text' }> Guardar </span>
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showMassive} onHide={ () => setShowMassive(false) }>
        <Modal.Header closeButton>
          <div className="title-form">{ 'Librería - Carga Masiva Libros' }</div>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Form id='visitorForm' onSubmit={ sendForm }>
              <div>
                <div> Puedes subir un <span style={{ color: "#ae0107" }}>ARCHIVO</span> .xlsx para poder subir varios <b>libros</b> a la vez. </div>
                <br/>
                <input required ref={ inputRef } className='file' type="file" name="libros" onChange={ (e) => setFile(e.target.files[0]) } style={{ fontSize: '11px' }} />
                <br/>
                <div align="right">
                  <Button disabled={ loading } className='single-btn' type="submit">
                    <Spinner animation="border" variant="light" role="status" className={ loading ? 'spin' : 'hide' }/>
                    <span className={ loading ? 'hide' : 'btn-text' }> Guardar </span>
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>

      <Offcanvas show={showDesc} onHide={ () => setShowDesc(false) } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form">{ titulo }</div>
            <div className="desc-form">{ descripcion }</div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Container>
            <Row>
              <div>
                <Container>
                  <Row>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Código ISBN </div>
                      <div>{ codigoisbn }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Autor </div>
                      <div>{ autor }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Proveedor Principal </div>
                      <div>{ provPrincipal ? getNombreProveedor(provPrincipal).razonSocial : '' }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Proveedor Secundario </div>
                      <div>{ provSecundario ? getNombreProveedor(provSecundario).razonSocial : '' }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Editora </div>
                      <div>{ idEditora ? getNombreEditorial(idEditora).editora: '' }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Precio </div>
                      <div>{ precio }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Costo </div>
                      <div>{ costo }</div>
                    </Col>
                  </Row>
                </Container>
                
                <br/>
                <div align="center">
                { parseInt(rol) === 2 && <> <button type="button" onClick={ () => { setShowDesc(false); setShow(true); } } className="grl-btn"> <Pencil />&nbsp;&nbsp;Editar </button>&nbsp;&nbsp; </> }
                  <button type="button" onClick={ () => { setShowDesc(false); setIdLibro(idLibro); setShowAlmacen(true); } } className="grl-btn"> <Archive />&nbsp;&nbsp;Almacenes</button>&nbsp;&nbsp;
                  <button type="button" onClick={ () => { setShowDesc(false); setIdLibro(idLibro); setShowProv(true); } } className="grl-btn"> <BoxSeam />&nbsp;&nbsp;Proveedores</button>
                </div>
              </div>
            </Row>
          </Container>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas show={show} onHide={ () => setShow(false) } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form">{ action }</div>
            <div className="desc-form"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form id="driveForm" onSubmit={ updateItem }>
            <Container>
              <Row>
                <div>
                  <input type="hidden" name="idLibro" value={ idLibro } />
                  <input type="hidden" name="estatus" value={ estatus } />
                  <Container>
                    <Row>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Código ISBN">
                            <Form.Control required name="codigoIsbn" value={ codigoisbn } onChange={ (e) => setCodigoisbn( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Título">
                            <Form.Control required name="titulo" value={ titulo } onChange={ (e) => setTitulo( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>

                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Descripción">
                            <Form.Control required name="descripcion" value={ descripcion } onChange={ (e) => setDescripcion( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Autor">
                            <Form.Control required name="autor" value={ autor } onChange={ (e) => setAutor( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Proveedor Principal">
                            <Form.Select required name="provPrincipal" value={ provPrincipal } onChange={ (e) => setProvPrincipal( e.target.value ) }>
                              <option>Selecciona una opción</option>
                              { proveedoresList.map( item => (
                                <option key={ item.idProveedor } value={ item.idProveedor }>{ item.razonSocial }</option>
                              ))}
                            </Form.Select>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Proveedor Secundario">
                            <Form.Select required name="provSecundario" value={ provSecundario } onChange={ (e) => setProvSecundario( e.target.value ) }>
                              <option>Selecciona una opción</option>
                              { proveedoresList.map( item => (
                                <option key={ item.idProveedor } value={ item.idProveedor }>{ item.razonSocial }</option>
                              ))}
                            </Form.Select>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Editorial">
                            <Form.Select required name="idEditora" value={ idEditora } onChange={ (e) => setIdEditora( e.target.value ) }>
                              <option>Selecciona una opción</option>
                              { editorasList.map( item => (
                                <option key={ item.idEditora } value={ item.idEditora }>{ item.editora }</option>
                              ))}
                            </Form.Select>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Precio">
                            <Form.Control name="precio" type="number" value={ precio } onChange={ (e) => setPrecio( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Costo">
                            <Form.Control name="costo" type="number" value={ costo } onChange={ (e) => setCosto( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Container>
                  
                  <br/>
                  <div align="center">
                    <button type="button" className="cancel-btn" onClick={ () => setShow(false) } >{ 'Cancelar' }</button>&nbsp;&nbsp;
                    <button type="submit" className="grl-btn">{ 'Guardar' }</button>
                  </div>
                </div>
              </Row>
            </Container>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas show={showAlmacen} onHide={ () => setShowAlmacen(false) } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form"> Libro en Almacenes </div>
            <div className="desc-form"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <LibroAlmacen idLibro={ idLibro }/>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas show={showProv} onHide={ () => setShowProv(false) } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form"> Proveedores del libro </div>
            <div className="desc-form"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <LibroProv idLibro={ idLibro }/>
        </Offcanvas.Body>
      </Offcanvas>

      <Container className='main-component'>
        <Row>
          <Col md={ 4 }>
            <div className="section-subtitle"> Lista de Libros </div>
            <br/>
          </Col>
          <Col md={ 8 } align="right">
            { parseInt(rol) === 2 && 
              <>
                <span className="single-btn" onClick={ () => showForm() } > <PlusLg />&nbsp; Nuevo </span> &nbsp;&nbsp;&nbsp;&nbsp;
                <span className="single-btn" onClick={ onDownload } > <FileExcelFill />&nbsp;  Descargar Inventario </span> &nbsp;&nbsp;&nbsp;&nbsp;
                <span className="single-alt-btn" onClick={ () => showMasiveFile() } > <Upload />&nbsp; Carga Masiva Libros </span>
                {/*<span className="single-alt-btn" onClick={ () => showAlmacenMasiveFile() } > Carga Masiva Salidas </span> &nbsp;&nbsp;&nbsp;&nbsp;*/}
              </>
            }
          </Col>
        </Row>

        <Row>
            <Col md={ 4 }>
              <Form.Group className='mb-3'>
                <FloatingLabel label="Buscar por nombre o Código ISBN">
                  <Form.Control id="search" value={filterText} onChange={ (e) => setFilterText(e.target.value) } placeholder="" />
                </FloatingLabel>
              </Form.Group>
            </Col>
            <Col md={ 4 }>
              <Form.Group className='mb-3'>
                <FloatingLabel label="Proveedor">
                  <Form.Select required name="filterProveedor" value={ filterProveedor } onChange={ (e) => setFilterProveedor( e.target.value ) }>
                    <option value="-1" >Selecciona una opción</option>
                    { proveedoresList.map( item => (
                      <option key={ item.idProveedor } value={ item.idProveedor }>{ item.razonSocial }</option>
                    ))}
                  </Form.Select>
                </FloatingLabel>
              </Form.Group>
            </Col>
            <Col md={ 4 }>
              <Form.Group className='mb-3'>
                <FloatingLabel label="Editorial">
                  <Form.Select required name="filterEditorial" value={ filterEditorial } onChange={ (e) => setFilterEditorial( e.target.value ) }>
                    <option value="-1" >Selecciona una opción</option>
                    { editorasList.map( item => (
                      <option key={ item.idEditora } value={ item.idEditora }>{ item.editora }</option>
                    ))}
                  </Form.Select>
                </FloatingLabel>
              </Form.Group>
            </Col>
        </Row>

        <Row>
          <Col>
            
            { filteredItems.length > 0 && 
              <>
                <DataTable
                  columns={columns}
                  data={filteredItems}
                  pagination
                  paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                  persistTableHead
                />
              </>
            }
            { filteredItems.length === 0 && 
              <div>Sin registros</div>
            }
            {/* <Table responsive>
              <thead>
                <tr>
                  <th>Código ISBN</th>
                  <th>Titulo</th>
                  <th>Autor</th>
                  <th>Editora</th>
                  <th>Proveedor</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                { librosList.length == 0 && 
                  <tr>
                    <td colSpan="6"> <div>Sin registros</div> </td>
                  </tr>
                }
                { librosList.map( item => (
                  <tr key={ item.idLibro }>
                    <td> 
                      <div className="item-link" onClick={ () => showForm(item, true) }> 
                        { item.codigoIsbn } 
                      </div>
                    </td>
                    <td> 
                        { item.titulo } 
                    </td>
                    <td> 
                      { item.autor } 
                    </td>
                    <td> 
                      { getNombreEditorial(item.idEditora).editora } 
                    </td>
                    <td> 
                      { getNombreProveedor(item.provPrincipal).razonSocial } 
                    </td>
                    <td align="right"> 
                      {  item.estatus ? 
                        <>
                          { parseInt(rol) === 2 && 
                            <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Editar</Tooltip>}>
                              <PencilFill onClick={ () => showForm(item) } className="table-icon" />
                            </OverlayTrigger>
                          }
                          <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Almacenes</Tooltip>}>
                            <ArchiveFill onClick={ () => { setIdLibro(item.idLibro); setShowAlmacen(true); } } className="table-icon" />
                          </OverlayTrigger>
                          <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Proveedores</Tooltip>}>
                            <BoxSeamFill onClick={ () => { setIdLibro(item.idLibro); setShowProv(true); } } className="table-icon" />
                          </OverlayTrigger>                      
                          { parseInt(rol) === 2 && 
                            <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Borrar</Tooltip>}>
                              <X onClick={ () => cancelProveedorMsg(item.idLibro) } className="table-icon" />
                            </OverlayTrigger>
                          }
                        </> : 
                        <>
                          <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Activar</Tooltip>}>
                            <Power onClick={ () => activeItem(item.idLibro) } className="table-icon" />
                          </OverlayTrigger>
                        </>
                      }
                    </td>
                  </tr>
                )) }
              </tbody>
            </Table>*/}
          </Col>
        </Row>
      </Container>

      <div className="hide-books">
        <table  ref={tableRef}>
          <tbody>
            <tr>
                <th>Código de Barras</th>
                <th>Titulo</th>
                <th>Editorial</th>
                <th>Proveedor</th>
                <th>Precio Unitario</th>
                <th>Descuento Proveedor</th>
                <th>Costo</th>
                { almacenList.map( item => (
                  <th>{ 'Cantidad en ' + item.almacen }</th>
                )) }
            </tr>
            { filteredItems.map( item => {
              let proveedor = getNombreProveedor( item.provPrincipal )
              console.log("hidden items", item)

              return <tr>
                <td>{ item.codigoIsbn }</td>
                <td>{ item.titulo }</td>
                <td>{ item.idEditora ? getNombreEditorial(item.idEditora).editora : '' }</td>
                <td>{ proveedor.razonSocial }</td>
                <td>{ item.precio }</td>
                <td>{ proveedor.descuento + ' %' }</td>
                <td>{ item.costo }</td>
                { almacenList.map( almacen => {
                  let find = item.librosAlmacen.find(o => o.libroAlmacenPK.idAlmacen === almacen.idAlmacen)
                  let cantidad = 0
                  if( find ) cantidad = find.cantidad

                  return <td>{ cantidad }</td>
                }) }
              </tr>
            })}
          </tbody>
        </table>
      </div>

    </>
  );
}

export default Libreria;
